<div class='apple-login-button'>
    <div tabindex="1" role="button" (click)="appleClick()">
        <span>{{ls.get('auth.appleButtonText')}}</span>
    </div>
</div>
  